<template>
  <div id="jumbo" class="container-fluid" data-v-d817d2d6></div>
  <div id="art" class="container">
    <h1>Powerful Series</h1>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Fall_Beauty_q.2f7bb156.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal16"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Fall Beauty (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Hope_q.13a3575a.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal17"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Hope (2024)</p>
      </div>
    </div>
    <div
      class="modal fade"
      id="exampleModal16"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body">
            <div
              id="carouselExampleControls16"
              class="carousel carousel-dark slide"
              data-bs-ride="carousel"
            >
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img
                    src="/img/Fall_Beauty.883a46cc.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Fall_Beauty_1.a2d937c9.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Fall_Beauty_2.c81d6f1f.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Fall_Beauty_3.5c325dea.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
              </div>
              <button
                class="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleControls16"
                data-bs-slide="prev"
              >
                <span class="carousel-control-prev-icon" aria-hidden="true"></span
                ><span class="visually-hidden">Previous</span></button
              ><button
                class="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleControls16"
                data-bs-slide="next"
              >
                <span class="carousel-control-next-icon" aria-hidden="true"></span
                ><span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div class="modal-footer">Fall Beauty, Acryl on Canvas, 100 x 100 cm (2024)</div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="exampleModal17"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body">
            <div
              id="carouselExampleControls17"
              class="carousel carousel-dark slide"
              data-bs-ride="carousel"
            >
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img
                    src="/img/Hope.d04676d6.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Hope_1.eb57d636.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Hope_2.c585f3d6.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Hope_3.497df2f9.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Hope_4.a9a5a202.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Hope_5.3e182688.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Hope_6.3a460587.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Hope_7.06712011.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Hope_8.21c7480f.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
              </div>
              <button
                class="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleControls17"
                data-bs-slide="prev"
              >
                <span class="carousel-control-prev-icon" aria-hidden="true"></span
                ><span class="visually-hidden">Previous</span></button
              ><button
                class="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleControls17"
                data-bs-slide="next"
              >
                <span class="carousel-control-next-icon" aria-hidden="true"></span
                ><span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div class="modal-footer">Hope, Acryl on Canvas, 100 x 100 cm (2024)</div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Pink_flower_2_q.4f2b746c.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal18"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Flower 2 (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Pure_Happiness_q.af9108d9.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal19"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pure Happiness (2024)</p>
      </div>
    </div>
    <div
      class="modal fade"
      id="exampleModal18"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body">
            <div
              id="carouselExampleControls18"
              class="carousel carousel-dark slide"
              data-bs-ride="carousel"
            >
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img
                    src="/img/Pink_flower_2.18c24527.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Pink_flower_2_2.1e7a1815.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Pink_flower_2_3.e8cf8d40.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Pink_flower_2_4.faefe3d9.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Pink_flower_2_5.b1e38226.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Pink_flower_2_6.f2fc5cd3.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
              </div>
              <button
                class="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleControls18"
                data-bs-slide="prev"
              >
                <span class="carousel-control-prev-icon" aria-hidden="true"></span
                ><span class="visually-hidden">Previous</span></button
              ><button
                class="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleControls18"
                data-bs-slide="next"
              >
                <span class="carousel-control-next-icon" aria-hidden="true"></span
                ><span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div class="modal-footer">Pink Flower 2, Acryl on Canvas, 100 x 100 cm (2024)</div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="exampleModal19"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body">
            <div
              id="carouselExampleControls19"
              class="carousel carousel-dark slide"
              data-bs-ride="carousel"
            >
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img
                    src="/img/Pure_Happiness.a7d441bb.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Pure_Happiness_1.ef66cb93.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Pure_Happiness_2.3e084a5b.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Pure_Happiness_3.b3cbf5e2.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Pure_Happiness_4.1a59419b.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
              </div>
              <button
                class="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleControls19"
                data-bs-slide="prev"
              >
                <span class="carousel-control-prev-icon" aria-hidden="true"></span
                ><span class="visually-hidden">Previous</span></button
              ><button
                class="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleControls19"
                data-bs-slide="next"
              >
                <span class="carousel-control-next-icon" aria-hidden="true"></span
                ><span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div class="modal-footer">Pure Happiness, Acryl on Canvas, 120 x 100 cm (2024)</div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Unleashed_q.8f929ebb.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal20"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Unleashed (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Paradisebird_q.4b6c91b5.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal21"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Paradise Bird (2024)</p>
      </div>
    </div>
    <div
      class="modal fade"
      id="exampleModal20"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body">
            <div
              id="carouselExampleControls20"
              class="carousel carousel-dark slide"
              data-bs-ride="carousel"
            >
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img
                    src="/img/Unleashed.d643fa9c.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Unleashed_1.a0d128c7.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Unleashed_2.c6709fd7.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Unleashed_3.35a20d2a.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Unleashed_4.6933acbb.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Unleashed_5.118619fd.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
              </div>
              <button
                class="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleControls20"
                data-bs-slide="prev"
              >
                <span class="carousel-control-prev-icon" aria-hidden="true"></span
                ><span class="visually-hidden">Previous</span></button
              ><button
                class="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleControls20"
                data-bs-slide="next"
              >
                <span class="carousel-control-next-icon" aria-hidden="true"></span
                ><span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div class="modal-footer">Unleashed, Acryl on Canvas, 200 x 150 cm (2024)</div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="exampleModal21"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body">
            <div
              id="carouselExampleControls21"
              class="carousel carousel-dark slide"
              data-bs-ride="carousel"
            >
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img
                    src="/img/Paradisebird.2e3f9d49.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Paradisebird_1.43010975.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Paradisebird_2.da872f0d.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
                <div class="carousel-item">
                  <img
                    src="/img/Paradisebird_3.cf7ca677.jpg"
                    class="img-fluid"
                    style="max-height: 70vh"
                    alt="..."
                  />
                </div>
              </div>
              <button
                class="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleControls21"
                data-bs-slide="prev"
              >
                <span class="carousel-control-prev-icon" aria-hidden="true"></span
                ><span class="visually-hidden">Previous</span></button
              ><button
                class="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleControls21"
                data-bs-slide="next"
              >
                <span class="carousel-control-next-icon" aria-hidden="true"></span
                ><span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div class="modal-footer">Paradise Bird, Acryl on Canvas, 100 x 100 cm (2024)</div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/King_fisher_quadrat.c8f295c7.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal12"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Kingfisher (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Pink_greenplosion.1823702f.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal13"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Greenplosion (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Energy_quadrat.ecab77f5.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal8"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Energy (2023)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Wonderland_1_q.fc91f617.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal22"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Wonderland 1 (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Flowerexplosion_quadrat.db485a2b.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal5"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Flower Explosion (2022)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Fireworks_quadratisch.275d9945.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal1"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Fireworks (2021)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Energy_II_quadrat.74160fc6.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal9"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Energy II (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Greenplosion_quadrat.48eded29.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal10"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Greenplosion (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Green_Energy_quadrat.e5c586ad.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal11"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Green Energy (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Vigour_quadrat.c45949e7.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal2"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Vigour (2023)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Pink_flower.166225a2.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal14"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Flower (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Greenplosion_big_q.4d15a321.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal15"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Big Greenplosion (2024)</p>
      </div>
    </div>
  </div>
  <div class="row justify-content-center" style="margin-top: 30px">
    <div class="col-12 col-md-4">
      <img
        src="/img/Candy_quadratisch.7dbc162c.jpg"
        class="img-fluid"
        alt="..."
        data-bs-toggle="modal"
        data-bs-target="#exampleModal4"
        style="width: 80%; cursor: pointer"
      />
      <p style="margin-top: 10px">Candy (2022)</p>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal1"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <img
            src="/img/IMG_9040_1.03f75524.jpg"
            class="img-fluid"
            alt="..."
            style="max-height: 70vh"
          />
        </div>
        <div class="modal-footer">Fireworks (2021)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal2"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <img
            src="/img/Vigour.5995b8a1.jpg"
            class="img-fluid"
            alt="..."
            style="max-height: 70vh"
          />
        </div>
        <div class="modal-footer">Vigour (2021)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal4"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <img
            src="/img/Big_one_1.3f807f5b.jpg"
            class="img-fluid"
            alt="..."
            style="max-height: 70vh"
          />
        </div>
        <div class="modal-footer">Candy (2022), 200 x 150 cm, Acryl on Canvas</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal5"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <img
            src="/img/Flowerexplosion.66d30ed1.png"
            class="img-fluid"
            alt="..."
            style="max-height: 70vh"
          />
        </div>
        <div class="modal-footer">Flower Explosion, Acryl on Paper, 80 x 100 cm (2022)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal8"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Energy.d035894f.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Energy_V.8b537a3b.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Energy_V2.a69da8ed.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Energy, Acryl on Canvas, 200 x 150 cm (2023)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal9"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls9"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Energy_II_V.865346c7.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Energy_II_V2.53a5dfcc.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls9"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls9"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Energy II, Acryl on Canvas, 200 x 150 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal10"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls10"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Greenplosion_V.b1f3b07f.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Greenplosion_V2.a229055b.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls10"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls10"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Greenplosion, Acryl on Canvas, 100 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal11"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls11"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Green_Energy_V.4da182cc.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Green_Energy_V2.479ec6cf.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls11"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls11"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Green Energy, Acryl on Canvas, 120 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal12"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls12"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/King_fisher_Ansicht.caf90d68.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/King_fisher_Ansicht1.3007d65f.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/King_fisher_Ansicht2.892749d6.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls12"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls12"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Kingfisher, Acryl on Canvas, 120 x 160 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal13"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls13"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Pink_Greenplosion_Ansicht1.803cdcab.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink_Greenplosion_Ansicht2.3641ebb5.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls13"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls13"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pink Greenplosion, Acryl on Canvas, 120 x 120 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal14"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls14"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Pink_flower_Ansicht1.6081c2ee.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink_flower_Ansicht2.099572c7.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls14"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls14"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pink Flower, Acryl on Canvas, 100 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal22"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls22"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Wonderland_1.d1301998.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Wonderland_1_1.39a5c8d6.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Wonderland_1_2.55017cca.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Wonderland_1_3.d5f348b8.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Wonderland_1_4.bca61df0.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Wonderland_1_5.ee1910fc.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls22"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls22"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Wonderland 1, Acryl on Canvas, 60 x 60 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal15"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls15"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Greenplosion_big.fe52d781.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Big_greenplosion_Ansicht1.2391b027.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Big_greenplosion_Ansicht2.cbb70c00.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Big_greenplosion_Ansicht3.fb02ddc8.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls15"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls15"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Big Greenplosion, Acryl on Canvas, 120 x 160 cm (2024)</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Powerful",
};
</script>
